import {
  computed,
  defineComponent,
  getCurrentInstance,
  onBeforeMount,
  ref,
} from 'vue';
import {
  RouteLocationMatched,
  RouteLocationNormalizedLoaded,
  useRoute,
} from 'vue-router';
import FullScreen from './FullScreen';
import './index.less';

import config, { isDev } from '@/config';
import dayjs from 'dayjs';
import { getUserInfo } from '@/api/system/user';
import { UserInfo, userStore } from '@/store/system/user';
import { xtsj } from '@/api/policeSituation/common';
import { getEnvironmentData } from '@/utils/env';
// import holographicArchives from "@/assets/images/system/holographic-archives.png"

export interface SystemMenuItem {
  key: string;
  name: string;
  isGrey: boolean;
  slots?: { overlay: () => JSX.Element };
  class?: string;
  isCenter?: boolean;
  children: SystemMenuItem[];
  isHide: boolean;
}

const dev = isDev();
export default defineComponent({
  setup() {
    const route = useRoute();
    console.log('route', route.path);
    const selectedKeys = ref([route.path]);
    const selectKey = ref(route.path);
    const handleFullscreen = () => {
      document.body.requestFullscreen();
    };
    const handleFullscreenExit = () => {
      document.exitFullscreen();
    };
    const dateStr = ref(dayjs().format(`YYYY-MM-DD HH:mm:ss`));
    const weekStr = ref(dayjs().day());
    // setInterval(() => {
    //   const newDate = new Date(dateStr.value).getTime() + 1000;
    //   dateStr.value = dayjs(newDate).format(`YYYY-MM-DD HH:mm:ss`);
    //   weekStr.value = dayjs(newDate).day();
    //   // console.log(dateStr.value);
    // }, 1000);

    const getNewDate = () => {
      // console.log('focus');
      xtsj().then((res) => {
        const newDate = new Date(res[0].xtsj).getTime();
        dateStr.value = dayjs(newDate).format(`YYYY-MM-DD HH:mm:ss`);
        weekStr.value = dayjs(newDate).day();
      });
    };
    // window.addEventListener('focus', getNewDate);
    const date = computed(() => {
      const arr = dateStr.value.split(' ');
      return arr[0];
    });
    const time = computed(() => {
      const arr = dateStr.value.split(' ');
      return arr[1];
    });
    const week = computed(() => {
      const data = ['日', '一', '二', '三', '四', '五', '六'];
      console.log('week');
      return `星期${data[weekStr.value]}`;
    });
    const systemUserStore = userStore();
    const handeLogout = () => {
      systemUserStore.logout();
    };
    const userInfo = computed(() => systemUserStore.info);
    const { config } = window as unknown as { config: { userInfo: UserInfo } };
    // const login = () => {
    //   systemUserStore.getUserInfo();
    // };
    // if (config.userInfo.name?.length > 0) {
    //   systemUserStore.setUserInfo(config.userInfo);
    // } else {
    //   login();
    // }
    // console.log(getEnvironmentData());

    const menuJson = computed<SystemMenuItem[]>(() => systemUserStore.menuList);

    return {
      selectedKeys,
      handleFullscreen,
      handleFullscreenExit,
      date,
      time,
      week,
      selectKey,
      handeLogout,
      userInfo,
      menuJson,
    };
  },

  watch: {
    $route: function (newVal: RouteLocationNormalizedLoaded) {
      this.selectedKeys = [newVal.path];
      this.selectKey = newVal.path;
    },
  },
  methods: {
    renderMenuItem(node: {
      icon: JSX.Element;
      title: string;
      url: string;
      key: string;
    }) {
      return (
        <a-menu-item title={node.title} key={node.key}>
          {/* <c-icon class="icon" type={node.icon} /> */}
          {node.icon}
          <router-link class="title" to={node.url}>
            {node.title}
          </router-link>
        </a-menu-item>
      );
    },
  },
  render() {
    const { handeLogout, userInfo } = this;
    const handleLogout = () => {
      sessionStorage.removeItem('userName');
      this.$router.push('/auth/login');
    };
    const slots = {
      overlay: () => (
        <a-menu slot="overlay">
          <a-menu-item onClick={handleLogout}>退出登录</a-menu-item>
        </a-menu>
      ),
    };
    const diseableLink = (
      menu: { key: number | string; name: string; isGrey: boolean },
      index: number
    ) => (
      <a
        class={`menu-item menu${index >= a.length / 2 ? '-right' : ''} ${
          this.selectKey === menu.key ? 'active' : ''
        } menu${index} menu-${menu.isGrey ? 'grey' : ''}`}
      >
        <span>{menu.name}</span>
      </a>
    );

    const link = (
      menu: { key: number | string; name: string },
      index: number
    ) => (
      <router-link
        to={menu.key}
        class={`menu-item menu${index >= 3 ? '-right' : ''} ${
          this.selectKey.indexOf(menu.key as string) > -1 ? 'active' : ''
        } menu${index}`}
      >
        <span class="name">{menu.name}</span>
      </router-link>
    );

    const a: {
      key: string;
      name: string;
      disabled: boolean;
      slots?: { overlay: () => JSX.Element };
      class?: string;
      isCenter?: boolean;
      isHide?: boolean;
      isGrey: boolean;
    }[] = [];
    this.menuJson.map(({ key, name, children, isHide, isGrey }, index) => {
      a.push({
        key,
        name,
        disabled: false,
        slots:
          children?.length > 0
            ? {
                overlay: () => (
                  <a-menu slot="overlay">
                    {children
                      .filter((item) => !item.isHide && item.isGrey !== true)
                      .map((item) => (
                        <>
                          <a-menu-item key={item.key}>
                            {link(
                              {
                                key: item.key,
                                name: item.name,
                              },
                              0
                            )}
                          </a-menu-item>
                        </>
                      ))}
                  </a-menu>
                ),
              }
            : undefined,
        class:
          index > this.menuJson.length / 2 - 1 ? 'earlyWarningAnalysis' : '',
        isHide,
        isGrey,
      });
      if (
        (this.menuJson.length % 2 === 0 &&
          index === this.menuJson.length / 2 - 1) ||
        (index > this.menuJson.length / 2 - 1 &&
          index < this.menuJson.length / 2)
      ) {
        a.push({
          isCenter: true,
          key: 'center',
          name: 'center',
          disabled: true,
          isGrey: false,
        });
      }
    });

    return (
      <div class="system-head">
        <div class="head-bg"></div>
        <div class="head">
          <div class="head-content">
            <div class="header-left">
              <div class="date">
                {/* {this.date}{' '}
                <span style={{ 'margin-left': '10px' }}>{this.time}</span> */}
              </div>
              {/* <div class="week">{this.week}</div> */}
              {/* <div class="border"></div> */}
            </div>

            <div class="system-title animate__animated animate__fadeInDown">
              {/* <div class="logo"></div> */}
              {config.title}
              {/* <div class="t"></div> */}
            </div>
            <div class="right">
              {/* <fullscreen-outlined
              onClick={handleFullscreen}
              class="fullscreen"
            /> */}
              {/* <div class="date">{this.date}</div> */}

              {/* <a-dropdown v-slots={slots} placement="bottomCenter">
                <div class="name">Admin</div>
              </a-dropdown>
              <FullScreen
                onExit={handleFullscreenExit}
                onFullscreen={handleFullscreen}
                class="fullscreen"
              /> */}
              {/* <div class="border"></div> */}
              {/* <div class="user">
                <div class="user-icon"></div>
                {userInfo.name}
              </div>
              <div class="org">{userInfo.orgName}</div>
              <div onClick={handeLogout} class="exit">
                退出
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  },
});
